import { UAParser } from 'ua-parser-js';

export const UserDevice = {
  Desktop: 'desktop',
  Mobile: 'mobile',
  Tablet: 'tablet',
  Unknown: 'unknown',
};

const getUserDevice = (userAgent) => {
  if (userAgent) {
    const parser = new UAParser(userAgent);
    const deviceType = parser.getDevice().type;
     // For some reason, ua-parser-js treats an undefined deviceType as desktop.
    if (!deviceType) {
      return UserDevice.Desktop;
    }
    if (deviceType === 'mobile' || deviceType === 'tablet') {
      return deviceType;
    }
  }
  return UserDevice.Unknown;
};

export default getUserDevice;



// WEBPACK FOOTER //
// ./src-react/lib/optimizely/getUserDevice.js